/**
 * Base class for upsell screens
 */
fx.ns("shared.screens", class BaseUpsellScreen extends fx.components.PopupPanel {
    constructor(options) {
        super();

        this._showBack = options && options.back !== undefined ? options.back : true;
        this._showNext = options && options.next !== undefined ? options.next : true;

        this.mode = "";

        this.showEffect = "hslideout";
        this.hideEffect = "hslidein";

        this.destroyOnSwitch = true;

        this._containerHeight = 480;

        this._styleChoice = "square";

        this.optionsChoices = [];
        this._choices = [];
        this._selectedOption;
        this._totalPrice = 0;

    }

    /********* GETTERS / SETTERS *********/

    get title() {
        return this._title;
    }

    set title(val) {
        this._title = val;
    }

    get containerHeight() {
        return this._containerHeight;
    }

    set containerHeight(val) {
        this._containerHeight = val;
    }

    get styleChoice() {
        return this._styleChoice;
    }

    set styleChoice(val) {
        this._styleChoice = val;
    }

    get selectedOption() {
        return this._selectedOption;
    }

    set selectedOption(val) {
        this._selectedOption = val;
    }

    get choices() {
        return this._choices;
    }

    set choices(val) {
        this._choices = val;
    }

    get currentChoice() {
        return this._currentChoice;
    }

    set currentChoice(val) {
        this._currentChoice = val;
    }

    get showBack() {
        return this._showBack;
    }

    set showBack(value) {
        this._showBack = value;
        this._updateNavigation();
    }

    get showNext() {
        return this._showNext;
    }

    set showNext(value) {
        this._showNext = value;
        this._updateNavigation();
    }

    get valign() {
        return this._valign;
    }

    // set vertical align
    set valign(val) {
        this._valign = val;
        this._setAlign();
    }

    /********* FUNCTIONS *********/

    create() {
        super.create();

        if (this._showBack) {
            this.backButton = new fx.components.Button({ label: fx.text("Revenir"), icon: fx.get("assets").arrowBack, className: "navigation" });
            this.addChild(this.backButton, { top: 0, left: 0 });
        }

     


    }

    build() {
        this.container = new fx.components.VBox("container " + (fx.browser.isDesktop ? "horizontal" : "vertical"));
        this.addChild(this.container, { top: fx.browser.isDesktop ? "center" : 50, left: 0, width: "100%", height: fx.browser.isDesktop ? this.containerHeight : "fill" });

        this.addTitle(this.title);

        if (fx.browser.isDesktop) {
            this.hContainer = new fx.components.HBox({ className: "center hboxContainer", align: "" });
            this.hContainer.valign = this.valign;
            this.container.addChild(this.hContainer, { width: "100%", height: 380 });

            this._setAlign();
        }

        for (let i = 0; i < this.choices.length; i++) {
            let choice = this.choices.getItemAt(i);
            let premium = false;
            if (choice.favorite && choice.data == 3)
                premium = true;

            let component = new shared.components.OptionChoice(this.styleChoice, choice.data, choice.asset, choice.name, choice.description, choice.price, choice.favorite, premium);
            component.addClass(fx.browser.isDesktop ? "horizontal" : "vertical");

            this.addChoice(component, premium);
        }

        // Select default option
        let elements = fx.dom.find(".OptionChoice");
        for (var i = 0; i < elements.length; i++) {
            let option = this.getChildFromUI(elements[i]);
            if (option.data == this._creationOptionId) {
                this._selectOption(option);
                break;
            }
        }

           if (this._showNext) {
            //this.nextButton = new fx.components.Button({ label: fx.text("Continuer"), className: "filled nextButton" + (fx.browser.isMobile ? " mobile" : "") });
            //this.addChild(this.nextButton, { bottom: fx.browser.isMobile ? 0 : 20, left: "center", width: fx.browser.isMobile ? "100%" : "auto" });
            //this.nextButton.visibleAtStart = false;

            /*this.nextButtonWithoutOption = new fx.components.Button({ label: fx.text(""), className: "nextButtonWithoutOption" + (fx.browser.isMobile ? " mobile" : "") });
            this.addChild(this.nextButtonWithoutOption, { bottom: fx.browser.isMobile ? 0 : 20, left: "center", width: fx.browser.isMobile ? "100%" : "auto" });
            this.nextButtonWithoutOption.visibleAtStart = true;*/

            this.nextButtonOrder = new fx.components.Button({ label: fx.text(""), className: "filled nextButtonOrder" + (fx.browser.isMobile ? " mobile" : "") });

            if (fx.browser.isDesktop)
                this.container.addChild(this.nextButtonOrder, { left: "center" , width : "max-content"});
            else
            {
                let footer = new fx.components.Box("footer");
                footer.addChild(this.nextButtonOrder, { left: "center" , width : "max-content", top : "center"});
                this.addChild(footer, { height : 90, left : 0, width : "100%", bottom : 0});
            }

            this.on("click", this.onOrder, this.nextButtonOrder);
            //this.nextButtonWithoutOption.visibleAtStart = false;
        }

        
        this._updateLabels();

    }

    // Add a title to the container
    addTitle(text) {
        this.container.addChild(new fx.components.Text({ text: text, className: "title" }), { width: "90%", height: "auto", left: "center" });
    }

    // Add a choice to the container
    // If isPremium is true, it will use a larger width for desktop
    // Otherwise, it will use the default width for mobile
    addChoice(choice, isPremium) {
        if (fx.browser.isDesktop) {
            let width = 250;
            if (isPremium)
                width = 350;
            this.hContainer.addChild(choice, { width: width, height: 370 });
        }
        else
            this.container.addChild(choice, { width: "90%", height: fx.browser.isDesktop ? 390 : 460, left: "center" });
    }

    /** * Update the navigation buttons visibility
     * based on the current state of the screen.
     */
    _updateNavigation() {
        if (this.backButton)
            this.backButton.toggle(this._showBack);

        //if (this.nextButton)
            //this.nextButton.toggle(this._showNext); 
    }

    // Update the choice when clicked
    // If the option is already selected, unselect it, otherwise select it
    _updateOptionChoice(option) {
        if ((this.selectedOption ? this.selectedOption.data : -1) == option.data)
            this._unselectOption();
        else
            this._selectOption(option);
    }

    // Select current option ( highlight it and set selectedOption )
    _selectOption(option) {
        if (option) {
            let elements = fx.dom.find(".OptionChoice");
            if (elements) {
                for (var i = 0; i < elements.length; i++) {
                    if (elements[i]) {
                        let element = this.getChildFromUI(elements[i]);
                        if (element.data != option.data) {
                            element.removeClass("selected");
                            element.setChecked(false);
                        }
                        else {
                            element.addClass("selected");
                            element.setChecked(true);
                        }
                    }
                }
            }
            this.selectedOption = option;
        }
    }

    // Unselect current option ( remove highlight and reset selectedOption )
    _unselectOption() {
        let elements = fx.dom.find(".OptionChoice");
        if (elements) {
            for (var i = 0; i < elements.length; i++) {
                if (elements[i]) {
                    let element = this.getChildFromUI(elements[i]);
                    element.removeClass("selected");
                    element.setChecked(false);
                }
            }
        }
        this.selectedOption = null;
    }

    _setAlign() {
        if (!this.initialized)
            return;

        this.hContainer.valign = this.valign;
    }

    // Build choices from options array
    buildChoicesFromOptions(options) {
        if (options.length == 0) return [];
        return options.toArray().map(opt => ({
            data: opt.id,
            asset: fx.assets["upsell-" + opt.editor_code], //new fx.Asset(opt.image),
            name: opt.name,
            description: opt.description,
            price: opt.price,
            favorite: opt.favorite
        }));
    }

    // update buttons labels
    _updateLabels() {
        let totalPrice = this._getTotalPrice();
        //this.nextButton.label = fx.text("Continuer (+ $ €)", totalPrice.toFixed(2));
        if (totalPrice == 0)
            this.nextButtonOrder.label = (fx.get("app") == "poster") ? fx.text("Continuer sans cadre") : fx.text("Continuer sans box");
        else
            this.nextButtonOrder.label = fx.text("Aller au panier (+ $ €)", totalPrice.toFixed(2));
    }

    // get total price of selected options
    _getTotalPrice() {
        let totalPrice = 0;
        if (this.data.selectedOptions) {
            for (var i = 0; i < this.data.selectedOptions.length; i++) {
                totalPrice += this.data.selectedOptions[i].price;
            }
        }
        if (this.selectedOption)
            totalPrice += this.selectedOption.price;
        return totalPrice;
    }

    // get option chunk with its code name (frame, paper_quality, etc..)
    _getOptionByCode(code) {
        this.optionsChoices = this.data.optionsChoices;
        for (var i = 0; i < this.optionsChoices.length; i++) {
            if (this.optionsChoices[i].editor_code == code) {
                return this.optionsChoices.getItemAt(i);
            }
        }
        this._update();
        return null;
    }

    // get option chunk with its index
    _getOptionByIndex(index) {
        this.optionsChoices = this.data.optionsChoices;
        for (var i = 0; i < this.optionsChoices.length; i++) {
            if (i == index) {
                this.setTitle(this.optionsChoices.getItemAt(i).code);
                this._creationOptionId = this._getCreationOptionId(index);
                return this.optionsChoices.getItemAt(i);
            }
        }
        this._update();
        return null;
    }

    setTitle(optionCode) {
        switch (optionCode) {
            case "paper_quality":
                this.title = fx.text("Et si on rajoutait un joli papier en plus ?");
                break;
            case "box":
                this.title = fx.text("Et pourquoi pas une box pour ranger vos photos ?");
                break;
            case "frame":
                this.title = fx.text("Pourquoi pas un cadre autour de votre chef d'oeuvre ?");
                break;
        }
    }

    /**
     * Update the visibility of the next button based on the selected option
     * and the number of optionsChoice available.
     * If there are multiple optionsChoice, the next button is shown only if an option is selected.
     * If there is only one optionChoice, the next button is always hidden and the order button is shown.
     */
    _updateNextButton() {
        /*if (this.optionsChoices.toArray().length > 1) {
            if (this.selectedOption) {
                //if (this.nextButton) this.nextButton.show();
                //if (this.nextButtonWithoutOption) this.nextButtonWithoutOption.hide();
                if (this.nextButtonOrder) this.nextButtonOrder.hide();
            } else {
                //if (this.nextButton) this.nextButton.hide();
                //if (this.nextButtonWithoutOption) this.nextButtonWithoutOption.show();
                if (this.nextButtonOrder) this.nextButtonOrder.hide();
            }
        } else {
            //if (this.nextButton) this.nextButton.hide();
            //if (this.nextButtonWithoutOption) this.nextButtonWithoutOption.hide();
            if (this.nextButtonOrder) this.nextButtonOrder.show();
        }*/
    }

    _getCreationOptionId(index) 
    {
        let upsellOptionId = this.data.creation.upsell_options[this.optionsChoices.getItemAt(index).code];
        if (upsellOptionId) 
        {
            for (var i = 0; i < this.optionsChoices.getItemAt(index).options.length; i++) {
                if (this.optionsChoices.getItemAt(index).options.getItemAt(i).id == upsellOptionId) {
                    return this.optionsChoices.getItemAt(index).options.getItemAt(i).id;
                }
            }
        }
    }

    /********* EVENTS *********/

    onReady() {
        super.onReady();

        if (this.backButton)
            this.on("click", this.onBack, this.backButton);
        //if (this.nextButton)
        //    this.on("click", this.onNext, this.nextButton);
        //if (this.nextButtonOrder)
        //    this.on("click", this.onOrder, this.nextButtonOrder);
        /*if (this.nextButtonWithoutOption)
            this.on("click", this.onNext, this.nextButtonWithoutOption);*/

        this.on("click", this.onClick, this.container);
    }

    _update() {
        this._updateNavigation();
        this._updateLabels();
        //this._updateNextButton();           // Update next button visibility based on selected option
    }

    onClick(e) {
        let element = fx.dom.parent(e.target, ".OptionChoice");
        if (element) {
            let option = this.getChildFromUI(element);
            this._updateOptionChoice(option);   // Update selected option (highlight it in view, save selectedOption..)
            this._updateLabels();               // Update buttons labels (total price)
            //this._updateNextButton();           // Update next button visibility based on selected option
        }
    }

    onBack() {
        if (this.data)
            this.data.event("previous-step");
    }

    /*onNext() {
        if (this.data) {
            if (!this.data.selectedOptions) this.data.selectedOptions = [];
            if (this.selectedOption)
                this.data.selectedOptions.push({ ...this.selectedOption });

            this.data.event("next-step");
        }
    }*/

    onOrder() {
        if (this.data) {
            if (!this.data.selectedOptions) this.data.selectedOptions = [];
            if (this.selectedOption)
                this.data.selectedOptions.push({ ...this.selectedOption });

            this.data.event("upsell-selected");
        }
    }

});
